"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformOrchestrator = void 0;
const TransformObjectRegistry_1 = require("./TransformObjectRegistry");
class TransformOrchestrator {
    constructor(config) {
        this.generators = [];
        this.objectRegistry = new TransformObjectRegistry_1.TransformObjectRegistry();
        this.generationQueue = [];
        this.generatorsByRunFor = new Map();
        for (const generator of config.generators) {
            this.generators.push(generator);
            if (generator.runsFor === null) {
                const existing = this.generatorsByRunFor.get(null) ?? [];
                existing.push(generator);
                this.generatorsByRunFor.set(null, existing);
            }
            else {
                const runsForArray = generator.runsFor;
                for (const objectType of runsForArray) {
                    const existing = this.generatorsByRunFor.get(objectType) ?? [];
                    existing.push(generator);
                    this.generatorsByRunFor.set(objectType, existing);
                }
            }
        }
    }
    transform(baseContext, returnObjectType) {
        for (const generator of this.generatorsByRunFor.get(null) ?? []) {
            for (const yieldedObject of generator.generate(null, baseContext)) {
                this.registerObject(yieldedObject);
            }
        }
        this.processGenerationQueue(baseContext);
        const primaries = this.objectRegistry.getPrimaries(returnObjectType);
        return primaries.map((obj) => obj.compiled);
    }
    registerObject(object, visitedObjects = new Set()) {
        if (this.objectRegistry.hasObject(object)) {
            return;
        }
        for (const dep of object.dependencies) {
            if (visitedObjects.has(dep)) {
                throw new Error(`Circular dependency detected: ${[...visitedObjects, dep].map((o) => `${o.constructor.name}(${o.deduplicationKey})`).join(' → ')}`);
            }
            if (!this.objectRegistry.hasObject(dep)) {
                this.registerObject(dep, new Set([...visitedObjects, dep]));
            }
        }
        for (const dep of object.creates) {
            if (visitedObjects.has(dep)) {
                continue;
            }
            if (!this.objectRegistry.hasObject(dep)) {
                this.registerObject(dep, new Set([...visitedObjects, dep]));
            }
        }
        if (this.objectRegistry.hasObject(object)) {
            return;
        }
        const isPrimary = this.objectRegistry.register(object);
        if (isPrimary) {
            this.generationQueue.push(object);
        }
        let current = object.parent;
        const visited = new Set([object]);
        while (current) {
            if (visited.has(current)) {
                throw new Error('Circular parent relationship detected');
            }
            visited.add(current);
            if (current.canAdd(object)) {
                if (current.isCompiled) {
                    throw new Error(`Cannot add child ${object.constructor.name} to compiled object: ${current.constructor.name}`);
                }
                current.add(object);
                break;
            }
            current = current.parent;
        }
    }
    processGenerationQueue(rootContext) {
        while (this.generationQueue.length > 0) {
            const item = this.generationQueue.shift();
            if (item === undefined) {
                break;
            }
            const objectConstructor = item.constructor;
            const matchingGenerators = this.generatorsByRunFor.get(objectConstructor) ?? [];
            for (const generator of matchingGenerators) {
                for (const yieldedObject of generator.generate(item, rootContext)) {
                    if (this.objectRegistry.hasObject(yieldedObject)) {
                        continue;
                    }
                    this.registerObject(yieldedObject);
                }
            }
        }
    }
    getRegistry() {
        return this.objectRegistry;
    }
}
exports.TransformOrchestrator = TransformOrchestrator;
//# sourceMappingURL=TransformOrchestrator.js.map